var styles = {"box":"Divider_box_m3aql_1","margin-top":"Divider_margin-top_m3aql_7","padding":"Divider_padding_m3aql_10","left":"Divider_left_m3aql_13","right":"Divider_right_m3aql_19","text":"Divider_text_m3aql_25"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
